// extracted by mini-css-extract-plugin
export default {"modal":"EditQualificationItemModal_modal__8Azub"};